import { render } from "./ModalAddBook.vue?vue&type=template&id=1f3c6df4&scoped=true"
import script from "./ModalAddBook.vue?vue&type=script&lang=js"
export * from "./ModalAddBook.vue?vue&type=script&lang=js"

import "./ModalAddBook.vue?vue&type=style&index=0&id=1f3c6df4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3c6df4"]])

export default __exports__